export enum TabValuesEnum {
  Badges = 'Badges',
  Points = 'Points',
}
